import { TitleCasePipe } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBlock, SimpleInputBlockItemBase } from '../../../../core/models/physician/form-doc-builder';

@Component({
  selector: 'app-form-block-container',
  templateUrl: './form-block-container.component.html',
  styleUrls: ['./form-block-container.component.scss']
})
export class FormBlockContainerComponent implements OnInit {
  @Input() block: FormBlock;
  @Output() blockChange = new EventEmitter<FormBlock>();
  @Input() index: number;
  @Output() removeBlock = new EventEmitter<number>()

  contentTypeOptions: any[];
  constructor(private _titlePipe: TitleCasePipe) { }

  ngOnInit() {
  }
  moveBlockItem(value: any) {
    //console.log('bv', value);
    if (value.action == 'r') {
      this.block.items.splice(value.index, 1);
    } else {
      var new_index = value.index + (value.action == 'd' ? 1 : -1);
      var arr = this.block.items;
      if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(value.index, 1)[0]);
      this.block.items = arr;
      this.setItemId(new_index);
    }
    this.setItemId(value.index);
    this.blockChange.emit(this.block);
  }

  addBlockItem() {
    var self = this;
    let item: any = {
      html5InputType: 'text',
      label: '',
      itemId: (self.block && self.block.items ? self.block.blockId + '-' + self.block.items.length.toString() : self.block.blockId + '-' + '0'),
      type: 0,
      value: null
    };

    self.block.items.push(item);

    console.log('addItem', self.block);
    this.blockChange.emit(this.block);
  }

  remove() {
    this.removeBlock.emit(this.index);
    this.blockChange.emit(this.block);
  }

  setItemId(ind: number) {
    let blockItem = this.block.items[ind];
    //console.log('item' + ind, blockItem);
    if (blockItem) {
      var itemId = (blockItem.question && blockItem.question.length > 0 ? this._titlePipe.transform(blockItem.question).split(' ').slice(0, 4).join('') :
        (blockItem.label && blockItem.label.length > 0 ? this._titlePipe.transform(blockItem.label).split(' ').slice(0, 4).join('') :
          (blockItem.role && blockItem.role.length > 0 ? this._titlePipe.transform(blockItem.role).split(' ').slice(0, 4).join('') + 'Sign' :
            (blockItem.patientInfo ? blockItem.patientInfo :
              (blockItem.type == 2 ? 'Paragraph' :
                (blockItem.type == 3 ? 'ProfileData' :
                  (blockItem.type == 5 ? 'Signature' :
                    (blockItem.type == 0 ? 'Input' :
                      (blockItem.type == 1 ? 'Selection' : 'Item')
                    ))))))));
      if (this.block.items && !(this.block.items.filter(i => i.itemId == itemId).length > 0)) {
        this.block.items[ind].itemId = itemId;
      } else {
        let counter = ind;
        while (this.block.items && (this.block.items.filter(i => i.itemId == (itemId + counter)).length > 0)) {
          counter++;
        }
        this.block.items[ind].itemId = itemId + counter;
      }
    }

    this.blockChange.emit(this.block);

    return true;
  }


}
